module.exports = __webpack_public_path__ + "img/payment.9bfee079.svg";